import { tv } from "tailwind-variants";

import { mainSectionsPaddings } from "@/common/constants";

export const getTestimonialsWithPartnersSectionClass = tv({ base: [mainSectionsPaddings, "mb-24 bg-primary-100"] });

export const getTestimonialsCarouselItemClass = tv({
  base: [
    "lg:px-2",
    "basis-11/12 lg:basis-4/12",
    "animate-duration-500! animate-fill-forwards! opacity-0 group-[.animate-intersected-in]/intersected:animate-fade-up",
  ],
});

export const getTestimonialsCardClass = tv({
  base: ["flex h-[470px] flex-col rounded-3xl bg-white p-5 lg:h-[545px] xl:px-9 xl:pt-9"],
});
